import React from 'react'

export const NurseryItemSkeleton: React.FC = () => {
  return (
    <div className="animate-pulse-card">
      <div className="relative w-full aspect-[16/9] bg-gray-200 rounded-lg mb-3"></div>

      <div className="pb-4">
        {/* Feature badges placeholder */}
        <div className="flex flex-wrap gap-2 my-3 mb-3">
          <div className="h-6 w-20 bg-gray-200 rounded-sm"></div>
          <div className="h-6 w-24 bg-gray-200 rounded-sm"></div>
          <div className="h-6 w-16 bg-gray-200 rounded-sm"></div>
        </div>

        {/* Name placeholder */}
        <div className="h-6 w-3/4 bg-gray-200 rounded-sm mb-2"></div>

        {/* Location placeholder */}
        <div className="flex items-start gap-2 mb-2">
          <div className="w-5 h-5 bg-gray-200 rounded-sm"></div>
          <div className="h-4 w-48 bg-gray-200 rounded-sm"></div>
        </div>

        {/* Info items placeholder */}
        <div className="flex flex-col gap-2 mb-4">
          {/* Accept class */}
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 bg-gray-200 rounded-sm"></div>
            <div className="h-4 w-24 bg-gray-200 rounded-sm"></div>
          </div>
          {/* Program hours */}
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 bg-gray-200 rounded-sm"></div>
            <div className="h-4 w-40 bg-gray-200 rounded-sm"></div>
          </div>
          {/* Reviews */}
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 bg-gray-200 rounded-sm"></div>
            <div className="h-4 w-20 bg-gray-200 rounded-sm"></div>
          </div>
        </div>

        {/* Highlights section placeholder */}
        <div className="mb-4 p-3 rounded-lg bg-gray-100">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-5 h-5 bg-gray-200 rounded-sm"></div>
            <div className="h-4 w-48 bg-gray-200 rounded-sm"></div>
          </div>
          <div className="space-y-1 pl-4">
            <div className="h-3 w-full bg-gray-200 rounded-sm"></div>
            <div className="h-3 w-5/6 bg-gray-200 rounded-sm"></div>
            <div className="h-3 w-4/5 bg-gray-200 rounded-sm"></div>
          </div>
        </div>

        {/* Check-in months placeholder */}
        <div className="flex flex-wrap gap-2">
          {[...Array(4)].map((_, index) => (
            <div key={index} className="h-8 w-16 bg-gray-200 rounded-sm" style={{ animationDelay: `${index * 0.1}s` }}></div>
          ))}
        </div>
      </div>
    </div>
  )
}
